import { useEffect, useLayoutEffect, useRef, useState } from "react";
const useOverflowedElements = ({ elementsIds, containerWidth, direction = 'right', maxLength, dependencies, gap = 0 })=>{
    const elementsRefs = useRef({});
    const [elementWidths, setElementWidths] = useState({});
    const [visibleElements, setVisibleElements] = useState(elementsIds);
    const [hiddenElements, setHiddenElements] = useState([]);
    const setElementRef = (id)=>(el)=>{
            elementsRefs.current[id] = el;
        };
    useLayoutEffect(()=>{
        if (!elementsIds.length) return;
        const allRefsExist = elementsIds.every((id)=>elementsRefs.current[id]);
        if (!allRefsExist) return;
        const widths = {};
        elementsIds.forEach((id)=>{
            const elementRef = elementsRefs.current[id];
            if (elementRef) widths[id] = elementRef.offsetWidth;
        });
        setElementWidths(widths);
    }, [
        elementsIds,
        dependencies
    ]);
    useEffect(()=>{
        const checkOverflow = ()=>{
            const availableWidth = containerWidth;
            let fitWidth = 0;
            const visible = [];
            const orderedIds = 'left' === direction ? [
                ...elementsIds
            ].reverse() : elementsIds;
            for (const id of orderedIds){
                var _elementWidths_id;
                const elementWidth = null != (_elementWidths_id = elementWidths[id]) ? _elementWidths_id : 0;
                const width = elementWidth + (visible.length > 0 ? gap : 0);
                const fitsByWidth = fitWidth + width <= availableWidth;
                const fitsByMaxLength = !maxLength || visible.length < maxLength;
                if (!fitsByWidth || !fitsByMaxLength) break;
                visible.push(id);
                fitWidth += width;
            }
            const orderedVisible = 'left' === direction ? [
                ...visible
            ].reverse() : visible;
            const hidden = elementsIds.filter((id)=>!orderedVisible.includes(id));
            setVisibleElements(orderedVisible);
            setHiddenElements(hidden);
        };
        checkOverflow();
        window.addEventListener('resize', checkOverflow);
        return ()=>window.removeEventListener('resize', checkOverflow);
    }, [
        elementWidths,
        containerWidth,
        elementsIds,
        direction,
        maxLength,
        dependencies,
        gap
    ]);
    return {
        visibleElements,
        hiddenElements,
        setElementRef
    };
};
export { useOverflowedElements };
